import { Adapter as r, getAdapter as i } from "../../../../adapter.js";
import { TierConfigurationModel as t } from "./tierConfiguration.model.js";
import { TierDesignAdapter as o } from "./tierDesign/tierDesign.adapter.js";
import { TierSettingsAdapter as n } from "./tierSettings/tierSettings.adapter.js";
class m extends r {
  adapt(e) {
    return new t({
      design: e.design ? i(o).adapt(e.design) : void 0,
      settings: e.settings ? i(n).adapt(e.settings) : void 0
    });
  }
  serialize(e) {
  }
}
export {
  m as TierConfigurationAdapter
};
//# sourceMappingURL=tierConfiguration.adapter.js.map
